import { dispatch } from '../index.js'
import { CUSTOMER_ACCOUNTING } from '../../config/actionTypes'

const { CONFIG } = CUSTOMER_ACCOUNTING

export const setAccountingRecipientType = payload =>
    dispatch({type: CONFIG.SET_ACCOUNTING_RECIPIENT_TYPE, payload})

export const setAccountingType = payload => 
    dispatch({type: CONFIG.SET_ACCOUNTING_TYPE, payload})

export const setTaskType = payload =>
    dispatch({type: CONFIG.SET_TASK_TYPE, payload})

export const setRecipientType = payload =>
    dispatch({type: CONFIG.SET_RECIPIENT_TYPE, payload})

export const setRecipient = payload =>
    dispatch({type: CUSTOMER_ACCOUNTING.SET_RECIPIENT, payload})

export const setSelectedMember = payload =>
    dispatch({type: CONFIG.SET_SELECTED_MEMBER, payload})

export const addService = payload =>
    dispatch({type: CUSTOMER_ACCOUNTING.ADD_SERVICE, payload})
    
export const delService = payload =>
    dispatch({type: CUSTOMER_ACCOUNTING.DEL_SERVICE, payload})

export const resetAll = () =>
    dispatch({type: CUSTOMER_ACCOUNTING.RESET_ALL})

export const sendAccounting = (user) =>
    dispatch({type: CUSTOMER_ACCOUNTING.SEND_ACCOUNTING, payload: user})
const exports = {
    setRecipient,
    setAccountingRecipientType,
    setTaskType,
    setRecipientType,
}
export default exports